export default "__VITE_ASSET__69297324__"